export default __webpack_public_path__ + "static/media/187.5071138c.gif";